// extracted by mini-css-extract-plugin
export default {"row":"WA88tNCHdsj0MssdYouN"};